module.exports = __webpack_public_path__ + "9a3f07394e7f938132241ed1b9e40afb.svg";